<template>
  <div class="container-1350">
    <div class="grid">
      <div>
        <h4>
          change password
        </h4>
        <div>
          <input type="password" name="" id="" placeholder="Current Password" />
          <input type="password" name="" id="" placeholder="New Password" />
          <input
            type="password"
            name=""
            id=""
            label="hello"
            placeholder="Confirm Password"
          />
          <btn
            color="transparent"
            textcolor="#FF0000"
            mode="outline"
            class="red-outlined"
          >
            Change password
          </btn>
        </div>
      </div>

      <div>
        <h4>contact upskill</h4>
        <textarea
          name=""
          id=""
          cols="25"
          rows="9"
          class="text-are"
          placeholder="Type message"
        ></textarea>
        <btn
          color="transparent"
          textcolor="#FF0000"
          mode="outline"
          class="red-outlined"
        >
          send message
        </btn>
      </div>
    </div>
  </div>
</template>

<script>
import btn from "./UButton";

export default {
  components: {
    btn,
  },
  created() {
    this.Loaded();
  },
};
</script>

<style scoped>
textarea::-webkit-input-placeholder {
  padding: 25px;
  color: black;
  font-family: "Open Sans", sans-serif;
}

textarea:-moz-placeholder {
  /* Firefox 18- */
  padding: 25px;
  color: black;
  font-family: "Open Sans", sans-serif;
}

textarea::-moz-placeholder {
  /* Firefox 19+ */
  padding: 25px;
  color: black;
  font-family: "Open Sans", sans-serif;
}

textarea:-ms-input-placeholder {
  padding: 25px;
  color: black;
  font-family: "Open Sans", sans-serif;
}

textarea::placeholder {
  padding: 25px;
  color: black;
  font-family: "Open Sans", sans-serif;
}
input::placeholder {
  color: black;
  font-family: "Open Sans", sans-serif;
}
.registration_next {
  width: 100%;
  margin-left: 0;
}
.registration_next:hover {
  color: #0062ff;
}
.text-are {
  width: 100%;
  border: 1px solid black;
}
.container-1350 {
  background-color: #f8f8f8;
  padding: 100px;
}
h4 {
  font-family: "Monstserrat", sans-serif;
  font-weight: bold;
  font-size: 18px;
  line-height: 29px;
  text-transform: uppercase;
}
input {
  background-color: white;
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid black;
}
.grid {
  display: grid;

  grid-template-columns: 2fr 4fr;
  grid-gap: 100px;
}
</style>
